

















































































































































































































































































































































































































































































































































































































































import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import SeletorDeProdutos from '@/components/produto/SeletorDeProdutos.vue'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import { ItemDaPreVenda, PreVenda } from '@/models/pre-venda/PreVenda'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import { converterProdutoParaProdutoSimples, displayNomeCompletoDoProduto, obterQuantidadePesadaNaBalanca } from '@/shareds/produto-shareds'
import { maiorOuIgualAZero, obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { FindClienteUseCase, FindConfiguracaoDaContaUseCase, FindFornecedorUseCase, FindLojaUseCase, FindProdutoUseCase } from '@/usecases'
import { ItemPreVendaUseCase } from '@/usecases/venda/ItemPreVendaUseCase'
import { PreVendaUseCase } from '@/usecases/venda/PreVendaUseCase'
import axios, { CancelTokenSource } from 'axios'
import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import VueQuagga from "vue-quaggajs"
import { DataOptions } from 'vuetify'
import DialogoDeCsvItemDaPreVenda from './DialogoDeCsvItemDaPreVenda.vue'
import SeletorDeCliente from '../clientes/SeletorDeCliente.vue'
import { Cliente, Desconto, FormCliente, Fornecedor, ItemDaVenda, Perfil, TabelaDePreco, Venda } from '@/models'
import { PERFIL_LOGADO } from '@/common/constants'
import { ParametrosParaAutenticacao } from '@/models/RegraDeNegocio'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import CampoDeItemDeVenda from '@/components/venda/CampoDeItemDeVenda.vue'
import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue'
import SeletorDeFornecedorComBusca from '@/components/fornecedor/SeletorDeFornecedorComBusca.vue'
import SeletorDeTabelaDePreco from '@/components/tabeladepreco/SeletorDeTabelaDePreco.vue'
import DialogoDeEdicaoDeCliente from '@/components/cliente/DialogoDeEdicaoDeCliente.vue'
import { criarCliente } from '@/shareds/cliente-shareds'
import { imprimirPreVenda, imprimirEtiquetaDeVolumesPreVenda, imprimirComprovanteDePreVendaJasper } from '@/shareds/venda-shareds'
import DialogoDeConferenciaPreVenda from './DialogoDeConferenciaPreVenda.vue'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import BotaoDeDescontoDoItem from './BotaoDeDescontoDoItem.vue'
import copy from 'copy-to-clipboard'
import AplicarTabelaDePrecoUseCase from '@/usecases/tabela-de-precos/AplicarTabelaDePrecoUseCase'
import { formatarMoeda } from '@/shareds/formatadores'

Vue.use(VueQuagga);

@Component({
	components: {
		SeletorDeProdutos,
		Confirmacao,
		SeletorDeLojasDoUsuario,
		DialogoDeCsvItemDaPreVenda,
		SeletorDeCliente,
		CampoDeItemDeVenda,
		SeletorDeUsuario,
		SeletorDeFornecedorComBusca,
		SeletorDeTabelaDePreco,
		DialogoDeEdicaoDeCliente,
		DialogoDeConferenciaPreVenda,
		CampoDecimal,
		BotaoDeDescontoDoItem,
	},
})
export default class DialogoDeCadastroDaPreVenda extends Vue {
	@Ref() dialogoCsv!: DialogoDeCsvItemDaPreVenda
	@Ref() readonly campoDeBusca!: CampoDeItemDeVenda
	@Ref() dialogoEdicaoDeCliente!: DialogoDeEdicaoDeCliente
	@Ref() dialogoDeConferenciaPreVenda!: DialogoDeConferenciaPreVenda
	@Ref() campoQuantidadeAtacado!: any

	pesquisa = ''
	mostra = false
	loading = false
	carregando = false
	showCamera = false
	totalRegistros = -1
	buscandoProduto = false
	salvandoPreVenda = false
	editandoPreVenda = false
	lojaSelecionada: string | null = null
	carregandoItemNaPreVenda = false
	preVenda: PreVenda = criarPreVenda()
	itensDaPreVenda: ItemDaPreVenda[] = []
	itemDePreVenda: ItemDaPreVenda = criarItemPreVenda()
	valorLido: string | null = null
	cancelando: string[] = []
	descontoDoItemAtual: Desconto = { isPercentual: false, valor: 0 }
	cancelToken: CancelTokenSource | null = null
	mostrarDialogoObservacao = false
	mostrarDialogoSelecaoProduto = false
	mostrarDialogoLeituraDeCodigoBarras = false
	cliente: Cliente | null = null
	fornecedor: Fornecedor | null = null
	quantidadeNoAtacado = 1
	quantidadeFracionada = 1
	carregandoImpressao = false
	carregandoImpressaoEtiqueta = false
	carregandoComprovante = false
	itensDaPreVendaParaConferencia: ItemDaPreVenda[] = []
	painelItensAberto: number | null = null
	preVendaPadraoIsAtacado = false
	clienteInput: Cliente | string | null = null
	cpfOuCnpjDoCliente: string | null = null
	criandoPreVenda = false
	cancelouDuranteCriacao = false
	criacaoPromise: Promise<PreVenda | null> | null = null
	cancelTokenCriacao: CancelTokenSource | null = null
	removendoPreVendaCriada = false
	descontoCapaTimer: ReturnType<typeof setTimeout> | null = null

	findClienteUseCase = new FindClienteUseCase()
	findFornecedorUseCase = new FindFornecedorUseCase()
	preVendaUseCase = new PreVendaUseCase()
	itemPreVendaUseCase = new ItemPreVendaUseCase()
	findProdutoUseCase = new FindProdutoUseCase()
	findConfiguracaoDaContaUseCase = new FindConfiguracaoDaContaUseCase()
	findLojaUseCase = new FindLojaUseCase()


	tiposDePreVendaBase = [
		{ text: 'Venda', value: 'venda' },
		{ text: 'Demonstração', value: 'demonstracao' },
		{ text: 'Consignação', value: 'consignacao' },
		{ text: 'Brinde', value: 'brinde' },
		{ text: 'Outras entradas', value: 'outras entradas' },
		{ text: 'Outras saídas', value: 'outras saidas' },
		{ text: 'Conserto', value: 'conserto' },
		{ text: 'Ativo', value: 'ativo' },
		{ text: 'Devolução entrada', value: 'devolucao entrada' },
		{ text: 'Devolução saída', value: 'devolucao saida' },
		{ text: 'Atacado', value: 'atacado'},
		{ text: 'Transferência', value: 'transferencia' },
	]

	readerSize = {
		width: 860,
		height: 480,
	}

	paginacao: DataOptions = {
		page: 1,
		itemsPerPage: 5,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	obrigatorio = obrigatorio
	maiorOuIgualAZero = maiorOuIgualAZero
	dateTimeToPtBrFormat = dateTimeToPtBrFormat
	copyToClipboard = copy
	AlertModule = AlertModule

	async mostrar(preVendaSelecionada?: PreVenda, editando?: boolean, copiandoVenda?: boolean) {
		this.preVenda = preVendaSelecionada || criarPreVenda()
		this.editandoPreVenda = editando || false

		if(copiandoVenda) {
			this.cliente = this.preVenda.cliente || null
			this.itensDaPreVenda = this.preVenda.itens
			this.lojaSelecionada = this.preVenda.loja?.id || null
			if(this.preVenda.cpfOuCnpjDoCliente && this.preVenda.tipoDePreVenda === 'devolucao saida') {
				const fornecedoresBuscados = await this.findFornecedorUseCase.find({busca: this.preVenda.cpfOuCnpjDoCliente})

				if (fornecedoresBuscados.content.length > 0) {
					this.fornecedor = fornecedoresBuscados.content[0]
				}
			}
		} else {
			if(this.preVenda.id || editando) {
				if (this.preVenda.identificador) {
					const preVendaCompleta = await this.preVendaUseCase
						.findPreVendaByIdentificador(this.preVenda.identificador)
						.catch(() => null)
					if (preVendaCompleta) {
						this.preVenda.tabelaDePreco = preVendaCompleta.tabelaDePreco
						this.preVenda.usaTabelaGenerica = preVendaCompleta.usaTabelaGenerica
					}
				}

				if(this.preVenda.cpfOuCnpjDoCliente && this.preVenda.tipoDePreVenda !== 'devolucao saida') {
					this.cliente = await this.findClienteUseCase.findClienteByCpfOuCnpj(this.preVenda.cpfOuCnpjDoCliente)
					this.clienteInput = this.cliente
				}

				if(this.preVenda.cpfOuCnpjDoCliente && this.preVenda.tipoDePreVenda === 'devolucao saida') {
					const fornecedoresBuscados = await this.findFornecedorUseCase.find({busca: this.preVenda.cpfOuCnpjDoCliente})

					if (fornecedoresBuscados.content.length > 0) {
						this.fornecedor = fornecedoresBuscados.content[0]
					}
				}

				this.lojaSelecionada = this.preVenda.loja?.id || null
				if (this.preVenda.usaTabelaGenerica) {
					this.preVenda.tabelaDePreco = this.opcoesAdicionaisDeTabela[0]
				}
				this.buscarItensDaPreVenda()
			} else {
				await this.salvarPreVenda()
			} 
		}

		this.mostra = true
	}

	async concluir() {
		try {
			this.salvandoPreVenda = true
			await this.salvarPreVenda()
			this.salvandoPreVenda = false
		} catch(e) {
			this.salvandoPreVenda = false
			AlertModule.setError(e)
		}

		this.fechar()
		this.$emit('buscarPreVendas')
	}

	fechar() {
		this.mostra = false
		this.carregando = false
		this.totalRegistros = -1
		this.itensDaPreVenda = []
		this.lojaSelecionada = null
		this.cliente = null
		this.fornecedor = null
		this.buscandoProduto = false
		this.preVenda = criarPreVenda()
		this.mostrarDialogoObservacao = false
		this.mostrarDialogoSelecaoProduto = false
		this.mostrarDialogoSelecaoProduto = false
		this.mostrarDialogoLeituraDeCodigoBarras = false
		this.paginacao = {
			page: 1,
			itemsPerPage: 5,
			sortBy: [],
			sortDesc: [],
			groupBy: [],
			groupDesc: [],
			multiSort: false,
			mustSort: false,
		}
		this.quantidadeNoAtacado = 1
		this.quantidadeFracionada = 1
		this.itensDaPreVendaParaConferencia = []
		this.preVendaPadraoIsAtacado = false
		this.clienteInput = null
		this.cancelouDuranteCriacao = false
		this.criacaoPromise = null
		this.criandoPreVenda = false
		if (this.descontoCapaTimer) {
			clearTimeout(this.descontoCapaTimer)
			this.descontoCapaTimer = null
		}
		this.descontoDoItemAtual = { isPercentual: false, valor: 0 }
	}

	async cancelar() {
		this.cancelouDuranteCriacao = true

		if (this.cancelTokenCriacao) {
			this.cancelTokenCriacao.cancel('Modal fechado durante criação da pré-venda')
		}

		try {
			if (this.preVenda.id && !this.editandoPreVenda) {
				await this.preVendaUseCase.remover(this.preVenda.id)
			} else if (this.criacaoPromise && !this.editandoPreVenda) {
				const criada = await this.criacaoPromise.catch(() => null)
				if (criada?.id) {
					await this.preVendaUseCase.remover(criada.id)
				}
			}
		} catch (e) {
			//
		}
  
		this.lojaSelecionada = null
		this.mostra = false
		this.carregando = false
		this.totalRegistros = -1
		this.itensDaPreVenda = []
		this.buscandoProduto = false
		this.mostrarDialogoObservacao = false
		this.mostrarDialogoSelecaoProduto = false
		this.mostrarDialogoSelecaoProduto = false
		this.mostrarDialogoLeituraDeCodigoBarras = false
		this.paginacao = {
			page: 1,
			itemsPerPage: 5,
			sortBy: [],
			sortDesc: [],
			groupBy: [],
			groupDesc: [],
			multiSort: false,
			mustSort: false,
		}
		this.quantidadeNoAtacado = 1
		this.quantidadeFracionada = 1
		this.itensDaPreVendaParaConferencia = []
		this.cliente = null
		this.preVendaPadraoIsAtacado = false
		this.preVenda = criarPreVenda()
		this.clienteInput = null
		this.cancelouDuranteCriacao = false
		this.criacaoPromise = null
		this.criandoPreVenda = false
	}

	@Watch('paginacao')
	onPaginacaoChange() {
		this.buscarItensDaPreVenda(false)
	}

	async buscarItensDaPreVenda(atualizarValorTotal = true) {
		if(!this.preVenda.id) return
		try {
			this.carregando = true
			this.cancelToken = axios.CancelToken.source()
			const params = {
				idPreVenda: this.preVenda.id || null,
				pesquisa: this.pesquisa,
				page: this.paginacao.page - 1,
				size: this.paginacao.itemsPerPage,
				sort: 'createdAt,desc',
			}

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			const listaDeItensDaVenda = await this.itemPreVendaUseCase.findItensDaPreVenda(params, axiosConfig)
			this.itensDaPreVenda = listaDeItensDaVenda.content
			this.totalRegistros = listaDeItensDaVenda.totalElements
			this.carregando = false

			if (atualizarValorTotal) this.atualizarValorTotalDaPreVenda()
		} catch(e) {
			this.carregando = false
			AlertModule.setError(e)
		}
	}

	async atualizarValorTotalDaPreVenda() {
		if (!this.preVenda.identificador) return
		try {
			const preVendaAtualizada = await this.preVendaUseCase
				.findPreVendaByIdentificador(this.preVenda.identificador)
			this.preVenda.valorTotal = preVendaAtualizada.valorTotal
		} catch (_) {
			// Best-effort: se falhar, totalDaPreVenda cai no fallback (soma dos itens carregados).
		}
	}

	@Watch('lojaSelecionada')
	async onChangeLojaSelecionada(lojaAtual, lojaAnterior) {	
		if (this.cancelouDuranteCriacao) return

		if (!this.editandoPreVenda){
			const loja = await this.findLojaUseCase.findLojaById(lojaAtual)
			this.preVendaPadraoIsAtacado = loja.configuracaoDaLoja.preVendaPadraoIsAtacado
			if (loja.configuracaoDaLoja.utilizaQtdFracionadaPorPadraoNaPreVenda && this.podeInformarQuantidadeDeProdutos) {
				this.preVenda.permitirQuantidadeFracionada = true
			}
			if (!this.preVenda.geradaDeUmaVenda) {
				this.preVenda.tabelaDePreco = loja.configuracaoDaLoja.tabelaDePrecoPreVenda || null
			}
		}

		if (!lojaAnterior && (!this.preVenda.id && !this.editandoPreVenda) && this.mostra) {
			await this.salvarPreVenda()
		}
	}

	async salvarPreVenda(): Promise<PreVenda | null> {
		if (!this.lojaSelecionada) return null
		if (this.criandoPreVenda) return this.criacaoPromise ?? null

		this.salvandoPreVenda = true
		this.criandoPreVenda = true

		const run: Promise<PreVenda> = (async () => {
			try {
				if (!this.lojaSelecionada) throw new Error('Loja não selecionada')
				this.preVenda.loja = await this.findLojaUseCase.findLojaById(this.lojaSelecionada)
				this.preVendaPadraoIsAtacado = this.preVenda.loja.configuracaoDaLoja.preVendaPadraoIsAtacado
				const usandoPrecoDeCadastro = this.tabelaSelecionadaEhPrecoDeCadastro
				const payload = usandoPrecoDeCadastro
					? { ...this.preVenda, tabelaDePreco: null, usaTabelaGenerica: true }
					: { ...this.preVenda, usaTabelaGenerica: false }
				const preVendaCriada = await this.preVendaUseCase.salvar(payload)
				this.preVenda = preVendaCriada
				if (usandoPrecoDeCadastro && !this.preVenda.tabelaDePreco) {
					this.preVenda.tabelaDePreco = this.opcoesAdicionaisDeTabela[0]
				}
				return preVendaCriada
			} finally {
				this.salvandoPreVenda = false
				this.criandoPreVenda = false
				this.criacaoPromise = null
			}
		})()

		this.criacaoPromise = run

		let criada: PreVenda | null = null
		try {
			criada = await run
		} catch (e) {
			criada = null
		} finally {
			if (this.cancelouDuranteCriacao && criada?.id && !this.editandoPreVenda) {
				try {
					await this.preVendaUseCase.remover(criada.id)
				} catch (_) {
					this.fechar()
				}
			}
		}

		return criada
	}

	@Watch('clienteInput')
	onChangeClienteInput(valor: Cliente | string | null) {
		if (!valor) {
			this.cliente = null
			this.cpfOuCnpjDoCliente = null
			this.preVenda.cpfOuCnpjDoCliente = null
			return
		}

		if (typeof valor === 'string') {
			this.cliente = null
			this.cpfOuCnpjDoCliente = valor
			this.preVenda.cpfOuCnpjDoCliente = valor
			return
		}

		this.cliente = valor
		this.cpfOuCnpjDoCliente = valor.cnpjOuCpf
		this.preVenda.cpfOuCnpjDoCliente = valor.cnpjOuCpf
	}

	@Watch('fornecedor', { deep: true })
	setCnpjDoFornecedorNaPreVenda() {
		if(this.fornecedor && this.fornecedor.cnpjOuCpf === this.preVenda.cpfOuCnpjDoCliente) return

		this.preVenda.cpfOuCnpjDoCliente = this.fornecedor 
			? this.fornecedor?.cnpjOuCpf 
			: null
	}

	async atualizarListaDeProdutos(item: ItemDaPreVenda) {
		this.carregandoItemNaPreVenda = true
		this.preVenda.itens = this.preVenda.itens ?? [];
		const existeItemNaLista = this.itensDaPreVenda.findIndex(itemLista =>
			itemLista.produto.id === item.produto.id,
		);

		try {
			if (this.totalRegistros >= 500 && existeItemNaLista === -1) {
				throw new Error('A solicitação excede o limite de 500 produtos')
			}

			if (!this.preVenda.id) {
				throw new Error('Pre venda não existe')
			}

			if (this.preVenda.tipoDePreVenda === 'atacado'){
				const qtdAtacado = this.quantidadeNoAtacado > 0 ? this.quantidadeNoAtacado : 1
				item.quantidade = this.preVenda.permitirQuantidadeFracionada ? qtdAtacado : Math.trunc(qtdAtacado)
			} else if (this.preVenda.permitirQuantidadeFracionada) {
				item.quantidade = this.quantidadeFracionada > 0 ? this.quantidadeFracionada : 1
			}
			
			item.quantidadeConferida = item.quantidadeConferida != null ? item.quantidadeConferida : 0

			if (this.preVenda.tipoDePreVenda === 'venda' && !this.preVenda.geradaDeUmaVenda && this.preVenda.tabelaDePreco != null) {
				item = await this.precificarItemDaPreVenda(item)
			}

			if (this.descontoDoItemAtual.valor > 0) {
				const precoDoItem = item.preco || 1
				const percentualDoDescontoItem = this.descontoDoItemAtual.isPercentual
					? this.descontoDoItemAtual.valor
					: (this.descontoDoItemAtual.valor / precoDoItem) * 100

				if (percentualDoDescontoItem > 99.99) {
					AlertModule.setError('Valor não pode ser maior que 99.99%')
					this.descontoDoItemAtual = { isPercentual: false, valor: 0 }
					this.carregandoItemNaPreVenda = false
					return
				}

				const params: ParametrosParaAutenticacao = {
					regra: 'pode-conceder-desconto-por-item',
					desconto: this.descontoDoItemAtual,
					item: this.converterParaItemDaVenda(item),
				}

				try {
					if (!UserLoginStore.permiteRegraDeNegocio('pode-conceder-desconto-por-item')) {
						throw new Error('Usuário não tem permissão para conceder desconto por item')
					}
					const perfil: Perfil = localStorage[PERFIL_LOGADO]
						? JSON.parse(localStorage[PERFIL_LOGADO])
						: null
					this.validarDescontoDoItemPreVenda(perfil, params, item)
				} catch (e) {
					AlertModule.setError(e)
					const resultado = await VendaModule.autenticarAcao(params)
					if (!resultado?.autenticado) {
						this.descontoDoItemAtual = { isPercentual: false, valor: 0 }
						this.carregandoItemNaPreVenda = false
						return
					}
				}

				const descontoTabelaValor  = item.descontoValor ?? 0
				const tabelaIsPercentual   = item.descontoIsPercentual ?? false
				const manualIsPercentual   = this.descontoDoItemAtual.isPercentual
				const manualValor          = this.descontoDoItemAtual.valor

				let finalIsPercentual: boolean
				let finalValor: number

				if (descontoTabelaValor === 0) {
					finalIsPercentual = manualIsPercentual
					finalValor        = manualValor
				} else if (tabelaIsPercentual === manualIsPercentual) {
					finalIsPercentual = manualIsPercentual
					finalValor        = descontoTabelaValor + manualValor
				} else {
					const preco = item.preco ?? 0
					if (preco > 0) {
						const tabelaEmPercent = tabelaIsPercentual
							? descontoTabelaValor
							: (descontoTabelaValor / preco) * 100
						const manualEmPercent = manualIsPercentual
							? manualValor
							: (manualValor / preco) * 100
						finalIsPercentual = true
						finalValor        = tabelaEmPercent + manualEmPercent
					} else {
						finalIsPercentual = manualIsPercentual
						finalValor        = manualValor
					}
				}

				item = {
					...item,
					descontoIsPercentual: finalIsPercentual,
					descontoValor: finalValor,
				}
			}

			this.preVenda.movimentouEstoque = await this.itemPreVendaUseCase.salvarOuAtualizarItemPreVenda(item, this.preVenda.id, this.preVenda.tipoDePreVenda)
			
			this.mostrarDialogoSelecaoProduto = false
			this.carregandoItemNaPreVenda = false

			if (this.preVenda.tipoDePreVenda === 'atacado'){
				this.blurCampoDeItem()
				this.focarQuantidadeAtacado()
			}
		} catch (error: any) {
			AlertModule.setError(error);
			this.mostrarDialogoSelecaoProduto = false
			this.carregandoItemNaPreVenda = false
		} finally {
			this.buscarItensDaPreVenda();
			this.painelItensAberto = 0
		}
	}

	async removerItemDaPreVenda(idItem: string) {
		if(!idItem) return
		if (!this.preVenda.id) return

		this.cancelando.push(idItem)
		try {
			await this.itemPreVendaUseCase.remover(idItem, this.preVenda.id)
			this.cancelando = this.cancelando.filter(id => idItem !== id)
			this.buscarItensDaPreVenda()
			AlertModule.setSuccess("Item removido da pré venda")
		} catch(e) {
			this.cancelando = []
			AlertModule.setError(e)
		}
	}

	beep() {
		const audio = document.querySelector('audio')
		if(!audio) return 
		audio.play()
	}

	async logIt(data: any) {
		this.showCamera = false
		this.buscandoProduto = true
		this.beep()
		this.valorLido = data.codeResult.code

		if (this.valorLido) {
			try {
				const produto = await this.findProdutoUseCase.findProdutoPorIdentificador(this.valorLido)

				const configuracaoDeConta = await this.findConfiguracaoDaContaUseCase.find()

				let quantidadeDeItens: number

				if (produto.unidadeDeMedida !== 'KG' && produto.unidadeDeMedida !== 'MT') {
					if (this.preVenda.tipoDePreVenda === 'atacado') {
						const q = Number(this.quantidadeNoAtacado) || 1
						const qtd = q > 0 ? q : 1
						quantidadeDeItens = this.preVenda.permitirQuantidadeFracionada ? qtd : Math.trunc(qtd)
					} else if (this.preVenda.permitirQuantidadeFracionada) {
						const q = Number(this.quantidadeFracionada) || 1
						quantidadeDeItens = q > 0 ? q : 1
					} else {
						quantidadeDeItens = 1
					}
				} else {
					quantidadeDeItens = obterQuantidadePesadaNaBalanca(
						'',
						configuracaoDeConta?.medida || 6,
						configuracaoDeConta?.eans || 7,
						configuracaoDeConta?.casasNumericas || 4,
					)
				}

				const item: ItemDaPreVenda = {
					id: '',
					produto: converterProdutoParaProdutoSimples(produto),
					quantidade: quantidadeDeItens,
					preco: produto.preco || 0,
					chaveNotaOrigem: '',
					quantidadeConferida: 0,
				}

				this.atualizarListaDeProdutos(item)
			} catch (error: any) {
				AlertModule.setError(error)
			} finally {
				this.buscandoProduto = false
				this.showCamera = true
			}
		}
	}

	get usuario() {
		return UserLoginStore.usuario
	}

	get podeInformarQuantidadeDeProdutos() {
		return UserLoginStore.permiteRegraDeNegocio('informar-quantidade-de-produtos')
	}

	mostrarDialogoDeCliente() {
		if (!this.preVenda) return
		const cliente: FormCliente = !this.cliente?.id
			? criarCliente()
			: JSON.parse(JSON.stringify(this.cliente))

		const indiceDaLoja = cliente.lojas.findIndex(loja => loja.id === this.preVenda?.loja?.id)
		if (indiceDaLoja === -1 && this.preVenda.loja) {
			cliente.lojas.push(this.preVenda.loja)
		}
		
		cliente.cnpjOuCpf = cliente.cnpjOuCpf || this.cpfOuCnpjDoCliente || ''
		this.dialogoEdicaoDeCliente.mostrar(cliente, !cliente.id)
	}

	atualizarClienteDaPreVenda(cliente: Cliente) {
		this.cliente = cliente
		this.clienteInput = cliente
		this.cpfOuCnpjDoCliente = cliente.cnpjOuCpf
		this.preVenda.cpfOuCnpjDoCliente = cliente.cnpjOuCpf
	}

	async imprimirEtiquetaPreVenda() {
		if (!this.cliente) return
		this.carregandoImpressao = true

		try {
			await imprimirPreVenda(this.preVenda.identificador, this.cliente.cnpjOuCpf)
		} catch (error: any) {
			AlertModule.setError(error)
			this.carregandoImpressao = false
		} finally {
			this.carregandoImpressao = false
		}
	}

	async mostrarDialogoConferencia() {
		this.cancelToken = axios.CancelToken.source()
		const params = {
			idPreVenda: this.preVenda.id || null,
			pesquisa: this.pesquisa,
			page: this.paginacao.page - 1,
			size: 500,
			sort: 'createdAt,desc',
		}

		const axiosConfig = {
			cancelToken: this.cancelToken.token,
		}
		const itens = await this.itemPreVendaUseCase.findItensDaPreVenda(params, axiosConfig)
		this.itensDaPreVendaParaConferencia = itens.content
		
		this.dialogoDeConferenciaPreVenda.mostrar()
	}

	async finalizarConferencia(){
		try {
			this.preVenda.situacao = 'Conferida'
		} catch (error: any){
			AlertModule.setError
		} finally {
			this.buscarItensDaPreVenda();
		}
	}

	async reabrirPreVendaConferida(){
		this.preVenda.situacao = 'Aberto'
	}

	async imprimirEtiquetaDeVolumesPreVenda(){
		if (!this.cliente) return AlertModule.setError("Necessário cliente cadastrado na pré venda")
		if (!this.preVenda.dataHoraCriacao) return AlertModule.setError("Necessário data de criação da pré venda.")
		if (this.preVenda.volumes <= 0 || !this.preVenda.volumes) return AlertModule.setError("Necessário preencher a quantia de volumes.")
		this.carregandoImpressaoEtiqueta = true

		try {
			await imprimirEtiquetaDeVolumesPreVenda(this.preVenda.identificador, this.cliente.cnpjOuCpf, this.preVenda.dataHoraCriacao, this.preVenda.volumes)
		} catch (error: any) {
			AlertModule.setError(error)
			this.carregandoImpressaoEtiqueta = false
		} finally {
			this.carregandoImpressaoEtiqueta = false
		}
	}

	async imprimirComprovantePreVenda() {
		if (!this.preVenda.id) return AlertModule.setError('Salve a pré-venda antes de imprimir o comprovante.')
		if (this.itensDaPreVenda.length === 0) return AlertModule.setError('Adicione itens antes de imprimir o comprovante.')
		this.carregandoComprovante = true
		try {
			await imprimirComprovanteDePreVendaJasper(this.preVenda.id)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregandoComprovante = false
		}
	}

	focarCampoDeItem() {
		if (!this.mostra) return
		const campo: any = this.campoDeBusca
		if (!campo) return

		this.$nextTick(() => {
			if (typeof campo.focus === 'function') {
				campo.focus()
				return
			}

			const input: HTMLInputElement | null =
      campo.$el?.querySelector('input') ?? null

			if (input) {
				input.focus()
      input.select?.()
			}
		})
	}

	focarQuantidadeAtacado() {
		if (!this.mostra) return
		const campo: any = this.campoQuantidadeAtacado
		if (!campo) return

		this.$nextTick(() => {
			if (typeof campo.focus === 'function') {
				campo.focus()
      campo.select?.()
      return
			}

			const input: HTMLInputElement | null =
      campo.$el?.querySelector('input') ?? null

			if (input) {
				input.focus()
      input.select?.()
			}
		})
	}

	blurCampoDeItem() {
		if (!this.mostra) return

		const campo: any = this.campoDeBusca
		if (!campo) return

		this.$nextTick(() => {
			if (typeof campo.blur === 'function') {
				campo.blur()
				return
			}

			const input: HTMLInputElement | null =
      campo.$el?.querySelector('input') ?? null

			if (input) {
				input.blur()
			}
		})
	}

	get headers() {
		const isVenda = this.preVenda.tipoDePreVenda === 'venda'
		const base: any[] = [
			{ text: 'Produto', value: 'produto.nome' },
			{ text: 'Sku', value: 'produto.sku' },
			{ text: 'Ean', value: 'produto.eans' },
			{ text: 'Quantidade', value: 'quantidade', align: 'center' },
		]
		if (isVenda) {
			base.push(
				{ text: 'Valor Un. (R$)', value: 'preco', align: 'center' },
				{ text: 'Total (R$)', value: 'total', align: 'center', sortable: false },
			)
		}
		base.push({ text: 'Ações', value: 'actions', sortable: false, align: 'center' })
		return base
	}

	get tiposDePreVenda() {
		if (this.editandoPreVenda || !this.preVendaPadraoIsAtacado) return this.tiposDePreVendaBase

		const atacado = this.tiposDePreVendaBase.find(i => i.value === 'atacado')
		const outros = this.tiposDePreVendaBase.filter(i => i.value !== 'atacado')
		this.preVenda.tipoDePreVenda = 'atacado'
		return atacado ? [atacado, ...outros] : this.tiposDePreVendaBase
	}

	onClienteNaoExiste(cpfDigitado: string) {
		this.cpfOuCnpjDoCliente = cpfDigitado
		this.preVenda.cpfOuCnpjDoCliente = cpfDigitado
		this.cliente = null
	}

	@Watch('preVendaPadraoIsAtacado')
	onChangePreVendaPadraoIsAtacado(novo: boolean, antigo: boolean) {
		if (!this.mostra) return
		if (this.editandoPreVenda) return
		if (novo === antigo) return

		if (novo) {
			this.preVenda.tipoDePreVenda = 'atacado'
		} else if (this.preVenda.tipoDePreVenda === 'atacado') {
			this.preVenda.tipoDePreVenda = 'venda'
		}
	}

	@Watch('preVenda.descontoValor')
	onDescontoValorCapaChange() { this.agendarSalvarDescontoCapa() }

	@Watch('preVenda.descontoIsPercentual')
	onDescontoIsPercentualCapaChange() { this.agendarSalvarDescontoCapa() }

	agendarSalvarDescontoCapa() {
		if (!this.preVenda.id) return
		if (this.descontoCapaTimer) clearTimeout(this.descontoCapaTimer)
		this.descontoCapaTimer = setTimeout(async () => {
			if (!this.preVenda.id) return

			const descontoValor = this.preVenda.descontoValor ?? 0
			const descontoIsPercentual = this.preVenda.descontoIsPercentual ?? false

			if (descontoValor > 0) {
				const params: ParametrosParaAutenticacao = {
					regra: 'pode-conceder-desconto',
					desconto: { isPercentual: descontoIsPercentual, valor: descontoValor },
				}

				if (descontoIsPercentual && descontoValor > 99.99) {
					AlertModule.setError('Valor não pode ser maior que 99.99%')
					this.preVenda.descontoValor = 0
					this.preVenda.descontoIsPercentual = false
					return
				}

				if (!descontoIsPercentual && descontoValor > this.totalDaPreVenda - 0.01) {
					AlertModule.setError('Valor maior que o total da pré venda')
					this.preVenda.descontoValor = 0
					this.preVenda.descontoIsPercentual = false
					return
				}

				try {
					if (!UserLoginStore.permiteRegraDeNegocio('pode-conceder-desconto')) {
						throw new Error('Usuário não tem permissão para conceder desconto')
					}
					const perfil: Perfil = localStorage[PERFIL_LOGADO]
						? JSON.parse(localStorage[PERFIL_LOGADO])
						: null
					this.validarDescontoCapaPreVenda(perfil, params)
				} catch (e) {
					AlertModule.setError(e)
					const resultado = await VendaModule.autenticarAcao(params)
					if (!resultado?.autenticado) {
						this.preVenda.descontoValor = 0
						this.preVenda.descontoIsPercentual = false
						return
					}
				}
			}

			try {
				await this.preVendaUseCase.atualizarDescontoCapa(
					this.preVenda.id,
					descontoIsPercentual,
					descontoValor,
				)
			} catch (_) {
				// silently ignore auto-save errors
			}
		}, 600)
	}

	validarDescontoCapaPreVenda(perfil: Perfil, params: ParametrosParaAutenticacao) {
		if (!perfil || perfil.percentualMaximoDesconto === 0) return

		const desconto = params.desconto
		if (!desconto || desconto.valor <= 0) return

		let valorBrutoDaVenda = 0
		for (const item of this.itensDaPreVenda) {
			if (item.possuiDescontoPorTabela) {
				const descontoTabela = (item.descontoIsPercentual ?? false)
					? item.preco * ((item.descontoValor ?? 0) / 100)
					: (item.descontoValor ?? 0)
				valorBrutoDaVenda += item.preco - descontoTabela
			} else {
				valorBrutoDaVenda += item.preco
			}
		}

		const porcentagemDeDescontoDaCapa = desconto.isPercentual
			? desconto.valor
			: valorBrutoDaVenda > 0 ? (desconto.valor / valorBrutoDaVenda) * 100 : 0

		if (porcentagemDeDescontoDaCapa > perfil.percentualMaximoDesconto) {
			throw new Error(
				`O desconto aplicado é de ${porcentagemDeDescontoDaCapa.toFixed(2)}%, mas o limite permitido para a capa da venda é de ${perfil.percentualMaximoDesconto.toFixed(2)}%`,
			)
		}
	}

	async precificarItemDaPreVenda(item: ItemDaPreVenda): Promise<ItemDaPreVenda> {
		if (!this.preVenda || !this.preVenda.loja) return item

		if (this.tabelaSelecionadaEhPrecoDeCadastro) {
			const precoDeCadastro = item.produto?.preco
			if (!precoDeCadastro) {
				const sku = item.produto?.sku ? ` SKU: ${item.produto.sku}` : ''
				throw new Error(`Produto ${displayNomeCompletoDoProduto(item.produto)}${sku} está com preço zerado`)
			}
			return {
				...item,
				preco: precoDeCadastro,
				descontoIsPercentual: null,
				descontoValor: null,
				possuiDescontoPorTabela: null,
				percentualDescontoTabelaPreco: null,
				percentualCashback: null,
				diasParaEfetivarCashback: null,
				diasParaExpirarCashback: null,
				precoDeCusto: null,
			}
		}

		const loja = this.preVenda.loja.configuracaoDaLoja
			? this.preVenda.loja
			: await this.findLojaUseCase.findLojaById(this.preVenda.loja.id)

		if (!loja) return item

		const tipoDeCliente = this.cliente && this.cliente.tipoDeCliente
			? this.cliente.tipoDeCliente.nome
			: null

		const vendaAtual = {
			loja,
			cpfDoCliente: this.preVenda.cpfOuCnpjDoCliente,
			itens: [],
			isConsignado: false,
			isDemonstracao: false,
			isVendaReaberta: false,
			tipoDeTransacao: null,
			tipoNota: null,
		} as unknown as Venda

		const itemDaVenda = {
			produto: item.produto,
			quantidade: item.quantidade,
			preco: item.preco,
			desconto: { isPercentual: false, valor: 0 },
		} as unknown as ItemDaVenda

		const [itemComPreco] = await AplicarTabelaDePrecoUseCase({
			loja,
			itens: [itemDaVenda],
			tipoDeCliente,
			vendaAtual,
			validarLimiteDeProduto: false,
			tabelaDePreco: this.preVenda.tabelaDePreco ?? undefined,
			exigirProdutoNaTabela: true,
		})

		return {
			...item,
			preco: itemComPreco.preco || 0,
			descontoIsPercentual: itemComPreco.desconto?.isPercentual ?? null,
			descontoValor: itemComPreco.desconto?.valor ?? null,
			possuiDescontoPorTabela: itemComPreco.possuiDescontoPorTabela ?? null,
			percentualDescontoTabelaPreco: itemComPreco.percentualDescontoTabelaPreco ?? null,
			percentualCashback: itemComPreco.percentualCashback ?? null,
			diasParaEfetivarCashback: itemComPreco.diasParaEfetivarCashback ?? null,
			diasParaExpirarCashback: itemComPreco.diasParaExpirarCashback ?? null,
			precoDeCusto: itemComPreco.precoDeCusto ?? null,
		}
	}

	formatarMoeda(preco: number) {
		return formatarMoeda(preco)
	}

	get totalDaPreVenda(): number {
		if (this.preVenda.valorTotal != null) return this.preVenda.valorTotal
		return this.itensDaPreVenda.reduce((sum, item) => sum + this.calcularTotalDoItem(item), 0)
	}

	get preVendaTrabalhaComPreco(): boolean {
		return !!this.preVenda.tabelaDePreco
	}

	get opcoesAdicionaisDeTabela(): TabelaDePreco[] {
		return [
			{ id: ID_TABELA_PRECO_DE_CADASTRO, nome: 'Preço de cadastro do produto' } as TabelaDePreco,
		]
	}

	get tabelaSelecionadaEhPrecoDeCadastro(): boolean {
		const tabela = this.preVenda.tabelaDePreco
		const id = typeof tabela === 'string' ? tabela : tabela?.id
		return id === ID_TABELA_PRECO_DE_CADASTRO
	}

	get totalComDescontoDaPreVenda(): number {
		const total = this.totalDaPreVenda
		const descontoValor = this.preVenda.descontoValor || 0
		if (descontoValor <= 0) return total
		if (this.preVenda.descontoIsPercentual) {
			return Math.round(total * (1 - descontoValor / 100) * 100) / 100
		} else {
			return Math.round((total - descontoValor) * 100) / 100
		}
	}

	get temDescontoTotal(): boolean {
		return (this.preVenda.descontoValor || 0) > 0
	}

	get descontoEValido() {
		return () => {
			const valor = this.preVenda.descontoValor ?? 0
			const isPercentual = this.preVenda.descontoIsPercentual ?? false
			if (!isPercentual && valor > this.totalDaPreVenda - 0.01)
				return 'Valor maior que o total'
			if (isPercentual && valor > 99.99)
				return 'Valor não pode ser maior que 99.99%'
			return true
		}
	}

	get vendaDummy(): Venda {
		return { pagamentos: [] } as unknown as Venda
	}

	obterDescontoDoItem(item: ItemDaPreVenda): Desconto {
		return {
			isPercentual: item.descontoIsPercentual != null ? item.descontoIsPercentual : false,
			valor: item.descontoValor != null ? item.descontoValor : 0,
		}
	}

	validarDescontoDoItemPreVenda(perfil: Perfil, params: ParametrosParaAutenticacao, item: ItemDaPreVenda) {
		if (!params.desconto || !perfil || perfil.percentualMaximoDescontoPorItem === 0) return
		if (!perfil.permissoes.includes('pode-conceder-desconto-por-item')) {
			throw new Error('Usuário não tem permissão para conceder desconto por item')
		}
		const porcentagemDesconto = params.desconto.isPercentual
			? params.desconto.valor
			: (params.desconto.valor / (item.preco || 1)) * 100

		if (item.possuiDescontoPorTabela) {
			const percentualMaximo = Math.max(item.percentualDescontoTabelaPreco ?? 0, perfil.percentualMaximoDescontoPorItem)
			if (porcentagemDesconto > percentualMaximo) {
				throw new Error(
					(item.percentualDescontoTabelaPreco ?? 0) > perfil.percentualMaximoDescontoPorItem
						? `O desconto aplicado neste item (${porcentagemDesconto.toFixed(2)}%) excede o limite máximo permitido pela tabela de preço (${(item.percentualDescontoTabelaPreco ?? 0).toFixed(2)}%).`
						: `Este item tem um desconto de ${porcentagemDesconto.toFixed(2)}%, mas você só pode conceder até ${perfil.percentualMaximoDescontoPorItem}% de desconto por item. Ajuste o valor do desconto para não exceder o limite permitido.`,
				)
			}
		} else {
			if (porcentagemDesconto > perfil.percentualMaximoDescontoPorItem) {
				throw new Error(`Este item tem um desconto de ${porcentagemDesconto.toFixed(2)}%, mas você só pode conceder até ${perfil.percentualMaximoDescontoPorItem.toFixed(2)}% de desconto por item. Ajuste o valor do desconto para não exceder o limite permitido.`)
			}
		}
	}

	converterParaItemDaVenda(item: ItemDaPreVenda): ItemDaVenda {
		return {
			preco: item.preco || 0,
			quantidade: item.quantidade || 0,
			desconto: {
				isPercentual: item.descontoIsPercentual ?? false,
				valor: item.descontoValor ?? 0,
			},
			possuiDescontoPorTabela: item.possuiDescontoPorTabela ?? false,
			percentualDescontoTabelaPreco: item.percentualDescontoTabelaPreco ?? 0,
		} as ItemDaVenda
	}

	async salvarDescontoDoItem(item: ItemDaPreVenda, desconto: Desconto) {
		try {
			await this.itemPreVendaUseCase.atualizarDescontoDoItem(
				item.id,
				desconto.isPercentual,
				desconto.valor,
			)
			await this.buscarItensDaPreVenda()
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	calcularTotalDoItem(item: ItemDaPreVenda): number {
		const preco = item.preco || 0
		const quantidade = item.quantidade || 0
		const descontoValor = item.descontoValor ?? 0
		if (descontoValor > 0) {
			if (item.descontoIsPercentual) {
				return Math.round(preco * (1 - descontoValor / 100) * quantidade * 100) / 100
			} else {
				return Math.round((preco - descontoValor) * quantidade * 100) / 100
			}
		}
		return Math.round(preco * quantidade * 100) / 100
	}

	calcularTotalSemDesconto(item: ItemDaPreVenda): number {
		return Math.round((item.preco || 0) * (item.quantidade || 0) * 100) / 100
	}

	@Watch('preVenda.tipoDePreVenda')
	async onTipoDePreVendaChange() {
		if (!this.lojaSelecionada || this.preVenda.itens.length > 0) return
		if (this.preVenda.tipoDePreVenda === 'venda'){
			const loja = await this.findLojaUseCase.findLojaById(this.lojaSelecionada)
			this.preVenda.tabelaDePreco = this.preVenda.tabelaDePreco = loja.configuracaoDaLoja.tabelaDePrecoPreVenda || null
		} else {
			this.preVenda.tabelaDePreco = null
		}
	}
}

const ID_TABELA_PRECO_DE_CADASTRO = 'PRECO_DE_CADASTRO_DO_PRODUTO'

function criarPreVenda(): PreVenda {
	return {
		id: undefined,
		identificador: '',
		situacao: 'Aberto',
		dataHoraCriacao: null,
		itens: [],
		loja: null,
		cpfOuCnpjDoCliente: null,
		vendedor: null,
		tipoDePreVenda: 'venda',
		vendaIdOrigem: '',
		representante: null,
		percentualRepresentante: 0,
		volumes: 0,
		movimentouEstoque: false,
		geradaDeUmaVenda: false,
		permitirQuantidadeFracionada: false,
		tabelaDePreco: null,
		valorTotal: null,
		descontoIsPercentual: false,
		descontoValor: 0,
		usaTabelaGenerica: false,
	}
}

function criarItemPreVenda(): ItemDaPreVenda {
	return {
		id: '',
		produto: {	
			id: '',
			nome: '',
			tipo: 'Padrão',
			preco: 0,
			pesoLiquido: 0,
			pesoBruto: 0,
			descontoVarejo: 0,
			eans: [],
			sku: null,
			identificadores:[],
			nomeCompleto: '',
			produtoDesativado: false,
			isValePresente: false,
			urlImagens: null,
			skuPai: null,
			estacao: null,
			marca: null,
			categoria: null,
			genero: null,
			fornecedor: null,
		},
		quantidade: 0,
		preco: 0,
		chaveNotaOrigem: '',
		quantidadeConferida: 0,
	}
}
